import React, { useMemo, useRef } from 'react'
import SetupTab from 'modules/setup/setupTab/SetupTab'
import { TextBox, Label, RemoveModal } from 'components'
import { Row, Col, FormGroup } from 'react-bootstrap'
import { fetchUrl } from 'modules/util/functions'
import { useSetupTabValueContext, useSetupTabActionsContext } from 'modules/setup/setupTab/SetupTabContext'

const ProteccionInfoTab = () => {
	const { selectedId, form } = useSetupTabValueContext();
	const { onDelete, onError, onSuccess } = useSetupTabActionsContext();
	const _removeModal = useRef();

	const configuration = useMemo(() => ({
		urls: {
			get: "/proteccionSetup/getProteccionInfo",
			save: "/proteccionSetup/saveProteccionInfo",
			create: "/proteccionSetup/createProteccion"
		},
		getRequest: () => {
			return {
				idProteccion: selectedId
			}
		},
		saveRequest: (form) => {
			return {
				idProteccion: selectedId,
				nombre: form.nombre
			}
		}
	}), [selectedId]);

	const actions = [{
		key: "delete",
		name: "Borrar",
		onClick: () => {
			handleDelete();
		}
	}];

	// Handlers
	const handleDelete = () => {
		const rq = {
			idProteccion: selectedId
		};

		_removeModal.current.open({
			title: "Eliminando proteccion",
			name: form.nombre,
			onYes: () => {
				fetchUrl("/proteccionSetup/deleteProteccion", "post", rq, {
					success: (r) => {
						onSuccess(r.message);
						onDelete();
					},
					error: (r) => {
						onError(r.errorMessage);
					}
				}, { block: false });
			}
		});
	}

	return (
		<React.Fragment>
			<RemoveModal
				ref={_removeModal} />

			<SetupTab
				configuration={configuration}
				actions={actions}>
				<Row>
					<Col md={4}>
						<FormGroup>
							<Label required>Nombre</Label>
							<TextBox
								name="nombre"
								placeholder="Nombre" />
						</FormGroup>
					</Col>
				</Row>
			</SetupTab>
		</React.Fragment>
	)
}

export default ProteccionInfoTab;